// 接口api
import userApi from './modules/user' // 用户api

// 接口对象
const api = {
  ...userApi
}

export default api



// WEBPACK FOOTER //
// ./src/api/index.js